<div class="header-section">
  @if (profileModel()) {
    <app-profile-image
      [imageUrl]="profileModel().imageUrl"
      (imageUrlChange)="profileModel.set({...profileModel(), imageUrl: $event ?? ''})"
    />
    <div class="image-links">
      <a class="image-link">
        <img src="images/profile/favorites.png" alt="favorites" width="40" height="40">
        <span class="text1">Избранное</span>
      </a>
      <a class="image-link">
        <img src="images/profile/posts.png" alt="posts" width="40" height="40">
        <span class="text1">Посты</span>
      </a>
      <a class="image-link">
        <img src="images/profile/network.png" alt="network" width="60" height="40">
        <span class="text1">Контакты</span>
      </a>
    </div>
  }
</div>

@if (error) {
  <div class="common-error">
    Произошла ошибка: {{ error }}
  </div>
}
@if (profileModel()) {
  <div class="content">
    <form novalidate>
      <div>
        <input type="text" [formField]="profileForm.username" placeholder="Юзернейм" class="username-input form-input">
        @if (profileForm.username().touched() && !profileForm.username().valid()) {
          <div class="field-error">
            {{ profileForm.username().errors()[0]?.message }}
          </div>
        }
      </div>

      <div class="birthdate-container">
        <label for="birthdate">Дата рождения</label>
        <input type="date"
               class="birthdate-input form-input"
               min="1900-01-01"
               [max]="maxDate()"
               [ngModel]="profileModel().birthdate"
               (ngModelChange)="profileModel.set({...profileModel(), birthdate: $event}); profileForm.birthdate().markAsTouched()"
               name="birthdate"
        >
        @if (profileForm.birthdate().touched() && !profileForm.birthdate().valid()) {
          <div class="field-error">
            {{ profileForm.birthdate().errors()[0]?.message }}
          </div>
        }
      </div>

      <div>
        <textarea [formField]="profileForm.about" placeholder="Обо мне" rows="8" class="form-input"></textarea>
      </div>

      <div class="actions">
        <button type="submit" class="primary" [disabled]="!profileForm().valid()" (click)="saveProfile()">Сохранить</button>
      </div>
    </form>
  </div>
}
